import { NgIf } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router } from "@angular/router";
import { TranslocoPipe } from "@ngneat/transloco";
import { UserService } from "app/core/user/user.service";
import { ChangelogNewsModalComponent } from "app/modules/admin/changelog/news-modal/changelog-news-modal.component";
import { ChangelogService } from "app/modules/admin/changelog/services/changelog.service";
import { AcButtonComponent } from "app/shared/components/ac-button/ac-button.component";
import { Subject, take, takeUntil } from "rxjs";

@Component({
    selector: "changelog-button",
    standalone: true,
    templateUrl: "./changelog-button.component.html",
    styleUrls: ["./changelog-button.component.scss"],
    imports: [NgIf, MatIconModule, MatTooltipModule, TranslocoPipe, AcButtonComponent],
})
export class ChangelogButtonComponent implements OnInit, OnDestroy {
    unreadCount = 0;
    canView = false;
    private _unsubscribeAll: Subject<void> = new Subject<void>();
    private _modalShown = false;

    constructor(
        private _router: Router,
        private _userService: UserService,
        private _changelogService: ChangelogService,
        private _matDialog: MatDialog
    ) {}

    ngOnInit(): void {
        this._userService.user$.pipe(takeUntil(this._unsubscribeAll)).subscribe((user) => {
            const role = user?.role;
            this.canView = role === "admin" || role === "owner" || role === "super-admin";
            if (this.canView && user?.id) {
                this._maybeShowNewsModal();
            }
        });

        this._changelogService
            .getUnreadCount()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((count) => {
                this.unreadCount = count;
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    openChangelog(): void {
        this._router.navigate(["/changelog"]);
    }

    private _maybeShowNewsModal(): void {
        if (this._modalShown) {
            return;
        }
        // take(1): the latest-unseen stream re-emits whenever the seen set
        // changes (e.g. our own optimistic markAsSeen below), so without
        // take(1) a previous release could trigger a second modal.
        this._changelogService
            .getLatestUnseenRelease()
            .pipe(take(1), takeUntil(this._unsubscribeAll))
            .subscribe((release) => {
                if (!release) {
                    return;
                }
                this._modalShown = true;
                this._changelogService.markAsSeen(release.id).subscribe({ error: () => {} });
                this._matDialog.open(ChangelogNewsModalComponent, {
                    data: { release },
                    panelClass: "changelog-news-modal",
                    maxWidth: "90vw",
                });
            });
    }
}
